import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

/**
 * Kartlar dağıtılmadan önceki 3-2-1 geri sayımı.
 *
 * Rakam her saniye kendi kimliğiyle yeniden giriyor (`key={left}`), böylece
 * `AnimatePresence` her sayıyı ayrı ayrı büyütüp söndürüyor — tek bir metnin
 * içeriğini değiştirmek aynı etkiyi vermiyordu.
 */
export function Countdown({ at }: { at: number }) {
  const [left, setLeft] = useState(() => Math.ceil((at - Date.now()) / 1000));

  useEffect(() => {
    setLeft(Math.ceil((at - Date.now()) / 1000));
    const id = setInterval(() => setLeft(Math.ceil((at - Date.now()) / 1000)), 120);
    return () => clearInterval(id);
  }, [at]);

  if (left <= 0) return null;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={left}
        className="countdown"
        initial={{ scale: 0.45, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 1.7, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 320, damping: 20 }}
      >
        {left}
      </motion.div>
    </AnimatePresence>
  );
}
